export const user_login_loading = "user/login/loading";
export const user_login_error = "user/login/error";
export const user_login_success = "user/login/success";
export const user_logout = "user/log/out";
export const AUTH_GOOGLE_SUCCESS="google/singup"